interface ICardLayout {
  children: React.ReactNode;
  classCard?: string;
  classBody?: string;
  className?: string;
}

const CardLayout = ({ children, classCard, classBody }: ICardLayout) => {
  return (
    <div className={`card ${classCard}`}>
      <div className={`card-body ${classBody}`}>{children}</div>
    </div>
  );
};

export default CardLayout;
